const alphabetMapping = {
  data () {
    return {
      unfrequentLetters: [1, 1, 0, 1, 1],
      alphabet: {
        'a': [0, 0, 0, 1, 1],
        'à': [0, 0, 0, 1, 1],
        'á': [0, 0, 0, 1, 1],
        'ã': [0, 0, 0, 1, 1],
        'A': [0, 0, 0, 1, 1],
        'À': [0, 0, 0, 1, 1],
        'Á': [0, 0, 0, 1, 1],
        'Ã': [0, 0, 0, 1, 1],
        'b': [1, 1, 0, 0, 1],
        'B': [1, 1, 0, 0, 1],
        'c': [0, 1, 1, 1, 0],
        'ç': [0, 1, 1, 1, 0],
        'C': [0, 1, 1, 1, 0],
        'Ç': [0, 1, 1, 1, 0],
        'd': [0, 1, 0, 0, 1],
        'D': [0, 1, 0, 0, 1],
        'e': [0, 0, 0, 0, 1],
        'é': [0, 0, 0, 0, 1],
        'è': [0, 0, 0, 0, 1],
        'ê': [0, 0, 0, 0, 1],
        'E': [0, 0, 0, 0, 1],
        'É': [0, 0, 0, 0, 1],
        'È': [0, 0, 0, 0, 1],
        'Ê': [0, 0, 0, 0, 1],
        'f': [0, 1, 1, 0, 1],
        'F': [0, 1, 1, 0, 1],
        'g': [0, 1, 0, 1, 0],
        'G': [0, 1, 0, 1, 0],
        'h': [1, 0, 1, 0, 0],
        'H': [1, 0, 1, 0, 0],
        'i': [0, 0, 1, 1, 0],
        'í': [0, 0, 1, 1, 0],
        'ì': [0, 0, 1, 1, 0],
        'I': [0, 0, 1, 1, 0],
        'Í': [0, 0, 1, 1, 0],
        'Ì': [0, 0, 1, 1, 0],
        'j': [0, 1, 0, 1, 1],
        'J': [0, 1, 0, 1, 1],
        'k': [0, 1, 1, 1, 1],
        'K': [0, 1, 1, 1, 1],
        'l': [1, 0, 0, 1, 0],
        'L': [1, 0, 0, 1, 0],
        'm': [1, 1, 1, 0, 0],
        'M': [1, 1, 1, 0, 0],
        'n': [0, 1, 1, 0, 0],
        'N': [0, 1, 1, 0, 0],
        'o': [1, 1, 0, 0, 0],
        'ó': [1, 1, 0, 0, 0],
        'ò': [1, 1, 0, 0, 0],
        'ô': [1, 1, 0, 0, 0],
        'õ': [1, 1, 0, 0, 0],
        'O': [1, 1, 0, 0, 0],
        'Ó': [1, 1, 0, 0, 0],
        'Ò': [1, 1, 0, 0, 0],
        'Ô': [1, 1, 0, 0, 0],
        'Õ': [1, 1, 0, 0, 0],
        'p': [1, 0, 1, 1, 0],
        'P': [1, 0, 1, 1, 0],
        'q': [1, 0, 1, 1, 1],
        'Q': [1, 0, 1, 1, 1],
        'r': [1, 1, 0, 1, 0],
        'R': [1, 1, 0, 1, 0],
        's': [0, 0, 1, 0, 1],
        'S': [0, 0, 1, 0, 1],
        't': [1, 0, 0, 0, 0],
        'T': [1, 0, 0, 0, 0],
        'u': [0, 0, 1, 1, 1],
        'ú': [0, 0, 1, 1, 1],
        'ù': [0, 0, 1, 1, 1],
        'U': [0, 0, 1, 1, 1],
        'Ú': [0, 0, 1, 1, 1],
        'Ù': [0, 0, 1, 1, 1],
        'v': [1, 1, 1, 1, 0],
        'V': [1, 1, 1, 1, 0],
        'w': [1, 0, 0, 1, 0],
        'W': [1, 0, 0, 1, 0],
        'x': [1, 1, 1, 0, 1],
        'y': [1, 0, 1, 0, 1],
        'Y': [1, 0, 1, 0, 1],
        'z': [1, 0, 0, 0, 1],
        'Z': [1, 0, 0, 0, 1],
        '1': [1, 0, 1, 1, 1],
        '2': [1, 0, 0, 1, 1],
        '3': [0, 0, 0, 0, 1],
        '4': [1, 1, 0, 1, 0],
        '5': [1, 0, 0, 0, 0],
        '6': [1, 0, 1, 0, 1],
        '7': [0, 0, 1, 1, 1],
        '8': [0, 0, 1, 1, 0],
        '9': [1, 1, 0, 0, 0]
      }
    };
  }
};

export default alphabetMapping;



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/alphabetMapping.js